import React, { useEffect } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";

import {
  getSupplierProductAction,
} from "../../../../modules/supplierProducts/Actions";

import { getSingelPendingSupplierAction, moderateCreateSinglePendingSupplierProductAction, updatePendingSupplierProductAction, getPendingSupplierProductsAction } from "../../../../modules/supplierModeration/supplierProducts/Actions"
import {
  supplierProductsIsLoadingSelector,
  supplierProductByIdSelector,
} from "../../../../modules/supplierProducts/Selectors";

import {
  InputField,
  CheckBox,
  TextArea,
  MultiInputField,
  SearchableSelect,
  MultiUpload,
  FormSectionTitle,
  Separator,
} from "../../../../components/form";

import ModerationForm from "../../../../components/form/ModerationForm";
import { pendingSupplierProductByIdSelector } from "../../../../modules/supplierModeration/supplierProducts/Selectors";
import axiosInstance from '../../../../helpers/api';
import { errorNotificationFromError } from '../../../../modules/notifications/Actions';

const SupplierProductsForm = (props) => {
  const {
    productId,
    moderationId,
    isLoading,
    updateSupplierProduct,
    getSupplierProduct,
    supplierProduct,
    moderateCreateSupplierProduct,
    getSupplierProducts
  } = props;

  useEffect(() => {
    // getSupplierProduct(productId);
    getSupplierProducts();
  }, [getSupplierProduct, productId]);

  return (
    <Formik
      enableReinitialize
      initialValues={{
        ...supplierProduct,
      }}
      onSubmit={(values) => {
        moderateCreateSupplierProduct({
          id: productId,
        }, values.moderationType);
      }}
    >
      {({ values, handleSubmit }) => (
        <>
          <ModerationForm
            handleSubmit={handleSubmit}
            isLoading={isLoading}
            heading={
              supplierProduct
                ? `Update [${supplierProduct.name}]`
                : "Create Supplier Product"
            }
          >
            <FormSectionTitle>Basic Information</FormSectionTitle>

            {/* <SearchableSelect
            name='supplierID'
            label='Supplier'
            getLabel='businessName'
          /> */}
            <InputField name="supplierData[0].businessName" label="Supplier" />
            <InputField name='name' label='Product Name' />
            <InputField name='productID' label='Product ID' />
            <SearchableSelect name='categoryData[0]' label='Category' />
            <SearchableSelect isMulti={true} name='tagsData[0]' label='Tags' />
            <TextArea name='description' label='Description' />
            <MultiInputField name='metaKeywords' label='Keywords' />
            <MultiInputField name='material' label='Material' />
            {/* <MultiInputField name='colors' label='Colors' /> */}
            <InputField name='size' label='Size' />
            <InputField name='usage' label='usage' />
            <InputField
              name='priceFrom'
              label='Price Range'
              placeholder='Price Range e.g. $200 USD'
            />
            <InputField
              name='priceTo'
              label='Price Range'
              placeholder='Price Range e.g. $200 USD'
            />

            <CheckBox name='discounted' label='Discounted' />
            {values.discounted && <InputField name='discount' label='Discount' />}
            {/*           {values.discounted && <DatePicker name='offerExpires' label='Offer Expires' />}
           */}
            <CheckBox name='hasBuyNowLink' label='Has Buy Now Link' />
            {values.hasBuyNowLink && (
              <InputField name='buyNowLink' label='Buy Now Link' />
            )}

            <MultiUpload
              data={{ customerID: "dsads9123213k219d120" }}
              S3Bucket='warshatna-users'
              API='customer/customer-category-image-signedurl/'
              data=''
              name='productImages'
              label='Product Image(s) :'
            />

            <Separator />
            <FormSectionTitle>Product Status</FormSectionTitle>
            <CheckBox name='packed' label='packed' />
            <CheckBox name='shippableLocal' label='shippable Local' />
            <CheckBox name='shippableInter' label='shippable International' />
            {/* <CheckBox name='status' label='status' />
          <CheckBox name='moderated' label='moderated' /> */}
          </ModerationForm>
          <button className="btn btn-secondary mb-3" onClick={async () => {
            try {
              let data = values;
              delete data.geolocation;
              await axiosInstance.put(`/supplier-product/${data.productSourceID}`, data);
              await axiosInstance.delete(`/supplier-product-staging/${supplierProduct._id}`);
              window.location.href = '/suppliers-moderation/suppliers'
            } catch (error) {
              errorNotificationFromError(error)
            }
          }} >Edit & Approve</button>
        </>
      )}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  const productId = props.match.params.id;
  const moderationId = props.match.params.moderationId;
  return {
    moderationId,
    productId,
    isLoading: supplierProductsIsLoadingSelector(state),
    supplierProduct: pendingSupplierProductByIdSelector(state, productId),

  };
};

export default connect(mapStateToProps, {
  getSupplierProduct: getSingelPendingSupplierAction,
  moderateCreateSupplierProduct: moderateCreateSinglePendingSupplierProductAction,
  getSupplierProducts: getPendingSupplierProductsAction
})(SupplierProductsForm);
